import { Component, OnInit, ViewChild } from '@angular/core';
declare var jquery: any;
declare var $: any;
import { ActivatedRoute, Router } from '@angular/router';
import { DownloadAssessmentManager } from '../../services/angular/DownloadAssessmentManager';
import { Globals } from '../../globals';
import { PreviousRouteService } from 'app/services/angular/GetPreviousRoute.service';
import { GridOptions } from 'ag-grid/main';
import { ToastrService } from 'ngx-toastr';
import { RatersService } from 'app/services/rater/RatersService';
import { ClientsService, RaterDto } from 'app/services/client/ClientsService';
import { CoachService, ImportRatersDto, UpdateRaterDto } from 'app/services/coach/CoachService';
import { AdminService } from 'app/services/admin/AdminService';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { RatersModalComponent } from '../raters-modal/raters-modal.component';
import { ReminderEmailModalComponent } from '../reminder-email-modal/reminder-email-modal.component';
import { DayViewModel } from 'ngx-bootstrap/datepicker/models';


@Component({
    selector: 'app-assessment-report',
    templateUrl: './assessment-report.component.html',
    styleUrls: ['./assessment-report.component.scss'],
    providers: [DownloadAssessmentManager]
})
export class CoachAssessmentReportComponent implements OnInit {

    @ViewChild('ratersModal', { static: true }) public ratersModal: RatersModalComponent;
    @ViewChild('reminderModal', { static: true }) public reminderModal: ReminderEmailModalComponent;
    // Graphic1
    ERGraphicDatasets: any[] = [];
    ERGraphicLabel: string[] = [];
    ERGraphicOptions: any = {
        scaleShowVerticalLines: true,
        responsive: true,
        scales: {
            xAxes: [{
                display: false,
                ticks: {
                    beginAtZero: true,
                    // max: 100
                }
            }],
            // yAxes: [{
            //    display: false,
            // }]
        },
        // animation: {
        //    duration: 1,
        //    onComplete: function () {
        //        var chartInstance = this.chart,
        //            ctx = chartInstance.ctx;
        //        ctx.textAlign = 'right';
        //        ctx.textBaseline = 'center';
        //        ctx.fillStyle = '#444';

        //        this.data.datasets.forEach(function (dataset, i) {
        //            var meta = chartInstance.controller.getDatasetMeta(i);
        //            meta.data.forEach(function (bar, index) {
        //                var data = dataset.data[index];
        //                ctx.fillText(data + "%", bar._model.x + 5, bar._model.y);
        //                //console.log('ctx', ctx);
        //            });
        //        });
        //    }
        // },
        hover: {
            animationDuration: 5
        },
        plugins: {
            datalabels: {
                display: false
            }
        },
        tooltips: {
            displayColors: false,
            titleSpacing: 0,
            titleMarginBottom: 0,
            xPadding: 5,
            yPadding: 2,
            callbacks: {
                label: (tooltipItem: any, data: any) => {
                    console.log('tooltipItem', tooltipItem);

                    const level = this.getLevelByIndex(tooltipItem);
                    return `Level ${level}: ${tooltipItem.xLabel}%`;
                }
            }
        }
    };

    ERGraphicLegend = false;
    ERGraphicChartType = 'horizontalBar';

    colors: Array<any> = [
        { // blue
            backgroundColor: '#1588eb',
            borderColor: 'rgba(0,192,192,1)',
            pointBorderColor: 'rgba(0,181,255,1)',
            pointBackgroundColor: 'rgba(255,255,255,1)',
            pointBorderWidth: 1,
        }
    ];

    // Graphic2
    ERPGraphicDatasets: any[] = [];
    ERPGraphicLabel: string[] = [];
    ERPGraphicOptions: any = {
        scaleShowVerticalLines: false,
        responsive: true,
        scales: {
            xAxes: [{
                display: false,
                ticks: {
                    display: false,
                    beginAtZero: true,
                    // max: 100
                }
            }]
        },
        plugins: {
            datalabels: {
                display: false
            }
        },
        tooltips: {
            displayColors: false,
            titleSpacing: 0,
            titleMarginBottom: 0,
            xPadding: 5,
            yPadding: 2,
            callbacks: {
                label: (tooltipItem: any, data: any) => {
                    console.log('tooltipItem', tooltipItem);

                    const level = this.getLevelByIndex(tooltipItem);
                    return `Level ${level}: ${tooltipItem.xLabel}%`;
                }
            }
        }
        // animation: {
        //    duration: 1,
        //    onComplete: function () {
        //        var chartInstance = this.chart,
        //            ctx = chartInstance.ctx;
        //        ctx.textAlign = 'left';
        //        ctx.textBaseline = 'center';
        //        ctx.fillStyle = '#444';

        //        this.data.datasets.forEach(function (dataset, i) {
        //            var meta = chartInstance.controller.getDatasetMeta(i);
        //            meta.data.forEach(function (bar, index) {
        //                var data = dataset.data[index];
        //                ctx.fillText(data + "%", bar._model.x + 5, bar._model.y);
        //            });
        //        });
        //    }
        // }
    };
    ERPGraphicLegend = false;
    ERPGraphicChartType = 'horizontalBar';

    ARL: any;
    EP: any;
    ESR: any;

    loadingMessage = 'Loading Asessment, please wait...';
    graphicTitle1 = '';
    graphicTitle2 = '';

    assignmentId: number;
    completedOn: string;
    client: string;
    niche: string;
    finish = false;

    levels1: any[] = [];
    levels2: any[] = [];
    assessmentAnswers: any[] = [];
    clientId: number;
    canSeeResults = false;
    sendReminderEmails = true;
    prevNavigation = '';
    assessmentName = '';
    raters: any[] = [];
    raterHeaders: any[] = [];
    gridOptions: GridOptions;
    raterGridOptions: GridOptions;
    raterGridApi: any;
    height: number;
    count: number;

    assignmentRaters: any[] = [];
    assignmentRatersHeaders: any[];
    assignmentRatersGridOptions: GridOptions;
    assignmentRatersGridApi;
    gridColumnApi;
    overlayNoRowsTemplate;
    ratersOverlayNoRowsTemplate;

    is360 = false;
    fileName = '';
    blobFile: any = null;

    /*new rater*/
    rater = {
        email: '',
        raterType: 0,
        firstName: '',
        lastName: ''
    }

    addingRater = false;
    raterTypes: any[] = [];
    currentTabSelected = 0;

    /*add raters modal*/
    settings = {
        bigBanner: false,
        timePicker: false,
        format: 'MM-dd-yyyy',
        defaultOpen: false
    };
    addRaterPageIdx = 0;
    importRaterPageIdx = 0;
    date1: Date = new Date();
    importDate: Date = new Date();
    hours: string[] = [
        '00:00 AM',
        '01:00 AM',
        '02:00 AM',
        '03:00 AM',
        '04:00 AM',
        '05:00 AM',
        '06:00 AM',
        '07:00 AM',
        '08:00 AM',
        '09:00 AM',
        '10:00 AM',
        '11:00 AM',
        '12:00 PM',
        '01:00 PM',
        '02:00 PM',
        '03:00 PM',
        '04:00 PM',
        '05:00 PM',
        '06:00 PM',
        '07:00 PM',
        '08:00 PM',
        '09:00 PM',
        '10:00 PM',
        '11:00 PM'
    ];
    languages: string[] = [];

    questions360_1: any[] = [];
    questions360_2: any[] = [];
    show360Section = true;

    graphic360_1_1_Options: any = {
        scaleShowVerticalLines: true,
        responsive: true,
        scales: {
            xAxes: [{
                display: true,
                ticks: {
                    beginAtZero: true,
                    max: 5
                }
            }],
            yAxes: [{
                barPercentage: 1.0,
                maxBarThickness: 30
            }]
        },
        tooltips: {
            enabled: true
        },
        hover: {
            animationDuration: 5
        },
        plugins: {
            datalabels: {
                anchor: 'end',
                align: 'end',
                offset: -20,
                color: '#fff',
                font: {
                    weight: 'bold'
                }
            }
        }
    };

    graphic360_1_1_Legend = false;
    graphic360_1_1_ChartType = 'horizontalBar';

    colors360: Array<any> = [
        { // blue
            backgroundColor: [
                '#4f81bd',
                '#c0504d',
                '#9bbb59',
                '#8064a2',
                '#4bacc6',
                '#4FBD8C',
                '#571485',
                '#4F671D',
                '#484937',
                '#135364'
            ],
            borderColor: [
                '#4f81bd',
                '#c0504d',
                '#9bbb59',
                '#8064a2',
                '#4bacc6',
                '#4FBD8C',
                '#571485',
                '#4F671D',
                '#484937',
                '#135364'
            ],
            pointBorderColor: 'rgba(0,181,255,1)',
            pointBackgroundColor: 'rgba(255,255,255,1)',
            pointBorderWidth: 1,
        }
    ];

    loading = false;
    reportGenerated: boolean;
    generatingReport = false;
    generatingResults = false;

    actionForRater = 'Add';
    raterForEdit: any;

    clientEmail: string;
    assessmentId: any;
    assessmentIdClientId: any;
    showGenerateResults = false;
    from: string;
    ratersComments: any[] = [];
    client_first_name = '';
    client_last_name = '';
    showDownloadFromAssignedAssessment = false;
    checkBoxReminderEnabled = true;
    sendingReminderEmails = false;
    progressRef: NgProgressRef;

    constructor(
        private _AdminService: AdminService,
        private _CoachService: CoachService,
        private _ClientsService: ClientsService,
        private _RatersService: RatersService,
        private activatedRoute: ActivatedRoute,
        private _DownloadAssessmentManager: DownloadAssessmentManager,
        private _Globals: Globals,
        private previousRouteService: PreviousRouteService,
        private _Toastr: ToastrService,
        private router: Router,
        public ngProgress: NgProgress
    ) {
        this.activatedRoute.params.subscribe(params => {
            console.log(params);
            this.assignmentId = params['assignmentId'];
            this.from = params['from'];
            if (parseInt(params['showGenerateResults'], 10) === 1) {
                this.showGenerateResults = true;
            } else {
                this.showGenerateResults = false;
            }

            if (String(this.from) === 'manage_assessments_assigned') {
                console.log('show download Report');
                this.showDownloadFromAssignedAssessment = true;
            }

            this.getAssignmentReminderEmailStatus();
        });
        this.overlayNoRowsTemplate = '<span>No row to show</span>';
        this.ratersOverlayNoRowsTemplate = '<span>There are no raters assigned to this assessment</span>';

    }



    ngOnInit() {
        this.progressRef = this.ngProgress.ref();
        this.raterGridOptions = <GridOptions>{};
        this.raterGridOptions.rowHeight = 45;
        this.raterGridOptions.headerHeight = 40;

        this.assignmentRatersGridOptions = <GridOptions>{};
        this.assignmentRatersGridOptions.rowHeight = 45;
        this.assignmentRatersGridOptions.headerHeight = 40;

        this.raterHeaders = this.createRatersHeaders();
        this.getRaters();

        this.GetCompletedAssessmentDetails();
        console.log(this.previousRouteService.getPreviousUrl());

        this.assignmentRatersHeaders = this.createAssignmentRaterHeaders();
        this.getAssignmentRatersConversionRate();

        this.getRaterTypesForCoach();
        this.getLanguages();

        this.subscriptions();
    }

    getLevelByIndex(tooltipItem): number {

        let currentLevel: number;

        switch (tooltipItem.index) {
            case 0:
                return currentLevel = 7;
            case 1:
                return currentLevel = 6;
            case 2:
                return currentLevel = 5
            case 3:
                return currentLevel = 4;
            case 4:
                return currentLevel = 3;
            case 5:
                return currentLevel = 2;
            case 6:
                return currentLevel = 1;
        }
    }

    getLanguages() {
        this._AdminService.getLanguages().subscribe((data: any) => {
            console.log('languages', data.result);
            const result = data.result.Result;

            if (result <= -10) {
                // this.toastr.warning('Expired token please login again.', 'ELI');
                this.router.navigate(['/login']);
                this._Globals.deleteAllStorage();
                return;
            }

            const _data = JSON.parse(data.result.Data);
            this.languages = _data;
        });
    }

    getRaterTypesForCoach() {
        this._CoachService.getRaterTypesForCoach().subscribe((data: any) => {
            console.log('response_GetRaterTypesForCoach', data);

            if (this._Globals.validationToken(data.result.Result)) {
                const _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                this.raterTypes = _data;
                this.rater.raterType = _data[0].Id;
            }
        });
    }

    markCheckBox() {
        if (this.canSeeResults) {
            this.showConfirmationCheckModal();
        } else {
            this.enableClientSeeResults();
        }
    }

    sendReminderEmailChange(event: any): boolean {
        event.preventDefault();
        event.stopPropagation();
        this.reminderModal.show();

        return false;
    }

    enableClientSeeResults() {
        this.loading = true;
        this._CoachService.postEnableClientSeeResults([this.assignmentId], this.canSeeResults).subscribe((data: any) => {
            console.log('PostEnableClientSeeResults_response', data);
            if (this._Globals.validationToken(data.result.Result)) {
                console.log(this.canSeeResults);
                if (this.canSeeResults) {
                    this.hideConfirmationCheckModal();
                    this._Toastr.success('Results shared successfully. Client is now able to see the assessment results', 'ELI');
                }
                this.loading = false;
                // if (data.result.Result == 1) {
                //    this._Toastr.success("", "ELI");
                // } else {
                //    this._Toastr.error("", "ELI");
                // }
            }
        });
    }

    confirmCheck() {
        this.enableClientSeeResults();
    }

    unCheck() {
        this.canSeeResults = false;
        console.log(this.canSeeResults);
    }

    showConfirmationCheckModal() {
        $('#confirmationCheckModal').modal({ backdrop: 'static' });
        $('#confirmationCheckModal').modal('show');
    }

    hideConfirmationCheckModal() {
        $('#confirmationCheckModal').modal('hide');
    }

    tabSelect(tabIndex: number) {
        console.log(tabIndex);
        this.currentTabSelected = tabIndex;

        if (tabIndex === 1) {
            setTimeout(() => {
                this.hideLevel('level1');
                this.hideLevel('level2');
                this.hideLevel('level3');
                this.hideLevel('level4');
                this.hideLevel('level5');
                this.hideLevel('level6');
                this.hideLevel('level7');
                this.hideLevel('satisfactionLevel1');
            }, 50);
        }
        if (tabIndex === 2) {
/*            this.sizeToFit(this.raterGridApi);*/
        }

        if (tabIndex === 3) {
            this.getAssignmentRatersConversionRate();
            this.sizeToFit(this.assignmentRatersGridApi);
        }

        if (tabIndex === 4) {
            if ( $('#Tab5').height() > 405 ) {
                $('.card').css('margin-right', '15px');
            }
        }
    }

    hideLevel(level: string) {
        $('.' + level).hide();
        $('.answerLevels .' + level).eq(0).show();
        $('.answerLevels .satisfactionLevel1').eq(0).show();
    }

    back() {
        window.history.back();
    }

    downloadClientAssessment() {
        console.log('download_client_assessment');
        this._DownloadAssessmentManager.downloadReport(this.clientId, this.assignmentId, 3, this);
    }

    downloadCoachAssessment() {
        console.log('download_coach_assessment');
        this._DownloadAssessmentManager.downloadReport(this.clientId, this.assignmentId, 2, this);
    }

    GetCompletedAssessmentDetails() {
        this._ClientsService.getCompletedAssessmentDetails(this.assignmentId).subscribe(data => {
            console.log('response_GetCompletedAssessmentDetails', data.result);
            this.completedOn = data.result.CompletedOn;
            this.client = data.result.ClientFirstName + ' ' + data.result.ClientLastName;
            this.niche = data.result.Niche;
            this.assessmentAnswers = data.result.AssessmentAnswers;
            this.assessmentName = data.result.AssessmentName;
            this.is360 = data.result.Is360;
            this.reportGenerated = data.result.ReportGenerated;
            console.log('reportGenerated', this.reportGenerated);
            // let assessmentCompleted = data.result.Completed;
            this.clientEmail = data.result.ClientEmail;
            this.assessmentIdClientId = data.result.ClientId;
            this.assessmentId = data.result.AssessmentId;
            this.ratersComments = data.result.RatersComments;
            this.client_first_name = data.result.ClientFirstName;
            this.client_last_name = data.result.ClientLastName;


            // let answersSection1 = this.assessmentAnswers[0].Answers;
            // let answersSection2 = this.assessmentAnswers[1].Answers;
            // this.assessmentAnswers[0].Answers = this.assessmentAnswers[0].Answers.sort(function (obj1, obj2) {
            //    // Ascending: first age less than the previous
            //    return obj1.QuestionNumber - obj2.QuestionNumber;
            // });

            this.clientId = data.result.ClientId;
            this.canSeeResults = data.result.ClientCanSeeResults;

            // tslint:disable-next-line: max-line-length
            this._Globals.setRouterUrls('edit_clients', 'app/edit_clients/' + data.result.ClientId + '/' + this.clientEmail + '/' + data.result.ClientFirstName + '/' + data.result.ClientLastName + '/Account%20Activated');

            if (this._Globals.getUserId() !== data.result.CoachId) {
                console.log('coachResultsDisplayToast');
                this._Globals.coachResultsDisplayToast = true;
                this.router.navigate(['/app/coach_home']);
            }

            data.result.AssessmentResults.forEach((x) => {
                switch (x.Id) {
                    case 1: {
                        this.ARL = x;
                        break;
                    }
                    case 2: {
                        this.EP = x;
                        this.graphicTitle1 = x.Name;
                        break;
                    }
                    case 3: {
                        this.ESR = x;
                        this.graphicTitle2 = x.Name;
                        break;
                    }
                }
            });

            const questions360_1 = data.result.Section1_360;
            const questions360_2 = data.result.Section2_360;

            console.log('questions pre formated', questions360_1);

            this.questions360_1 = this.retriveChartData(questions360_1);
            this.questions360_2 = this.retriveChartData(questions360_2);

            console.log('questions 360 1', this.questions360_1);
            console.log('questions 360 2', this.questions360_2);


            // graphic1
            const erData = [];
            this.EP.Values.forEach((x) => {
                // console.log(x);
                erData.unshift(x.Value);
            });

            this.EP.Values.forEach((x) => {
                // console.log(x);
                this.ERGraphicLabel.unshift(`                                   `); // Level ${ x.Level }
                this.levels1.unshift(x.Value);
            });


            this.ERGraphicDatasets = [
                {
                    data: erData,
                    label: 'Energy Value'
                }
            ];


            // Graphic2
            const erpData = [];
            this.ESR.Values.forEach((x) => {
                // console.log(x);
                erpData.unshift(x.Value);
            });

            this.ESR.Values.forEach((x) => {
                // console.log(x);
                this.ERPGraphicLabel.unshift(`                                   `); // Level ${ x.Level }
                this.levels2.unshift(x.Value);
            });

            this.ERPGraphicDatasets = [
                {
                    data: erpData,
                    label: 'Energy Value'
                }
            ];

            this.finish = true;
        });
    }

    retriveChartData(array: any[]): Array<any> { // return array of arrays
        const questionsFormated = [];


        if (array != null) {
            array.forEach((item) => {
                // console.log(item);
                const temItem = [];
                temItem.push(item.Text);
                temItem.push([{ data: this.retriveValues(item.Answers) }]);
                temItem.push(this.retriveLabels(item.Answers));

                questionsFormated.push(temItem);

            });
            return questionsFormated;
        } else {
            this.show360Section = false;
        }

    }

    retriveValues(array: any[]): Array<any> {
        const valuesFormated = [];

        array.forEach((item) => {
            valuesFormated.push(item.Points);
        });

        return valuesFormated;
    }

    retriveLabels(array: any[]): Array<any> {
        const labelsFormated = [];

        array.forEach((item) => {
            labelsFormated.push(item.RaterType);
        });

        return labelsFormated;
    }




    /*RATERs GRId*/

    getRaters() {
        this._ClientsService.getRaters(this.assignmentId).subscribe((data: any) => {
            console.log('response_GetRaters', data);

            if (this._Globals.validationToken(data.result.Result)) {
                const _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                this.raters = _data;
                // this.sizeToFit(this.raterGridApi);
            }
        });
    }

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit(gridApi: any) {
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onRaterGridReadyModal(params) {
        this.raterGridApi = params.api;

        if (!this.reportGenerated) {
            this.sizeToFit(this.raterGridApi);
            this.currentTabSelected = 2;
        }
    }

    createRatersHeaders() {
        const columnDefs = new Array();
        console.log('header');

        const emailHeader = {
            headerName: 'Email',
            field: 'Email',
            // headerCheckboxSelection: true,
            // headerCheckboxSelectionFilteredOnly: true,
            // checkboxSelection: true,
            minWidth: 200,
            width: 255,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(emailHeader);

        const nameHeader = {
            headerName: 'Name',
            field: 'Name',
            minWidth: 200,
            width: 300,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        const relationshipHeader = {
            headerName: 'Relationship',
            field: 'Relationship',
            minWidth: 150,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(relationshipHeader);

        // let addedByHeader = {
        //    headerName: 'AddedBy',
        //    field: 'AddedBy',
        //    minWidth: 200,
        //    width: 200,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return params.value;
        //    }
        // };
        // columnDefs.push(addedByHeader);

        const statusHeader = {
            headerName: 'Status',
            field: 'Status',
            minWidth: 150,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                switch (params.value) {
                    case 1:
                        return '<div style="overflow:hidden !important;text-overflow:ellipsis;">Pending</div>';
                    case 2:
                        return '<div style="overflow:hidden !important;text-overflow:ellipsis;">In progress</div>';
                    case 3:
                        return '<div style="overflow:hidden !important;text-overflow:ellipsis;">Completed</div>';
                }
            }
        };
        columnDefs.push(statusHeader);

        return columnDefs;
    }

    getAssignmentRatersConversionRate() {
        this._RatersService.getAssignmentRatersConversionRate(this.assignmentId).subscribe((data: any) => {
            console.log('response_getAssignmentRatersConversionRate', data);

            if (this._Globals.validationToken(data.result.Result)) {
                const _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                this.assignmentRaters = _data;
            }
        })
    }

    createAssignmentRaterHeaders() {
        const columnDefs = new Array();
        console.log('header');

        const nameHeader = {
            headerName: 'Name',
            field: 'RaterTypeName',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        const AssignedHeader = {
            headerName: 'Assigned',
            field: 'Assigned',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(AssignedHeader);

        const completedHeader = {
            headerName: 'Completed',
            field: 'Completed',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(completedHeader);

        const InProgressHeader = {
            headerName: 'InProgress',
            field: 'InProgress',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(InProgressHeader);

        const NotInitiatedHeader = {
            headerName: 'Not Initiated',
            field: 'NotInitiated',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(NotInitiatedHeader);



        return columnDefs;
    }

    onGridReady(params) {
        this.assignmentRatersGridApi = params.api;
        this.sizeToFit(this.assignmentRatersGridApi);
        setTimeout(() => {
            $('.ag-floating-filter-input').attr('placeholder', 'Filter');
        }, 100);
    }

    /**
     NOT IN USE
     */
    checkAssignmentRatersConversionRate(type: number) {
        if (this.is360) {
            this._RatersService.checkAssignmentRatersConversionRate(this.assignmentId).subscribe((data: any) => {
                console.log('response_GetCheckAssignmentRatersConversionRate', data);
                if (this._Globals.validationToken(data.result.Result)) {
                    const _data = JSON.parse(data.result.Data);
                    console.log('CheckAssignmentRatersConversionRate', _data);

                    if (_data) {
                        this.downloadAssessmentByUserType(type);
                    } else {
                        this._Toastr.error('No enough raters have completed the assessment', 'ELI');
                    }
                }
            });
        } else {
            this.downloadAssessmentByUserType(type);
        }

    }

    lockAssessment() {
        this.generatingResults = true;
        this.generatingReport = true;
        this._AdminService.postLockAssessment(this.assignmentId).subscribe((data: any) => {
            console.log('response_postLockAssessment', data);

            if (this._Globals.validationToken(data.result.Result)) {
                if (Number(data.result.Result) !== 1) {
                    this._Toastr.error('We are sorry an error happend while trying to generate the report. Please try Again.', 'ELI');
                } else {
                    this.reportGenerated = true;
                    console.log('reportGenerated', this.reportGenerated);
                    $('#Tab1').css('opacity', 0);
                }

                setTimeout(() => {
                    this.hideConfirmationGenerateReportModal();
                    this.generatingResults = false;
                    $('#Tab1').css('opacity', 1);
                }, 1000);
            }
        })
    }


    downloadAssessmentByUserType(type: number) {
        // coach
        if (Number(type) === 2) {
            this.downloadCoachAssessment();
        }
        // client
        if (Number(type) === 3) {
            this.downloadClientAssessment();
        }

        this.finish = false;
        setTimeout(() => {
            $('#loadingText').text('Downloading report...');
        }, 100)
        this.progressRef.start();
    }

    download() {
        this.generatingReport = true;
        this.downloadCoachAssessment();
        this.finish = false;
        $('#loadingText').text('Downloading report...');
        this.progressRef.complete();
    }


    /*add Raters*/

    saveRater() {
        const rater = new RaterDto();
        // rater.Email = this.rater.email;
        rater.ClientId = this.clientId;
        // rater.RaterType = this.rater.raterType;
        rater.AsignmentId = this.assignmentId;
        // rater.FirstName = this.rater.firstName;
        // rater.LastName = this.rater.lastName;

        let scheduledDate = $('.wc-date-container span').text();
        // this.scheduledDate = this.scheduledDate.slice(0, 10);
        const tempDate = scheduledDate.split(' ');
        scheduledDate = tempDate[0];
        scheduledDate = scheduledDate.replace(/-/g, '/');
        console.log('scheduledFor', scheduledDate);

        const language = $('#languages').val();
        console.log('language', language);

        let expiresIn = $('#expiresIn').val();
        console.log('expiresIn', expiresIn);

        const selectedHour = $('#hour').val();
        // this.selectedGtmText = $("#gtm option:selected").text();
        // this.selectedGtmValue = $('#gtm').val();
        const scheduleSelected = $('input[name=\'schedule\']:checked').val();

        console.log(selectedHour);
        console.log(scheduleSelected);


        rater.Language = language;
        const d = new Date();
        const n = d.getTimezoneOffset();
        const selectedGtmValue = (n / 60);

        rater.TimeOffSet = selectedGtmValue;
        if (expiresIn > 30) { expiresIn = 30; }
        rater.ExpiresIn = parseInt(expiresIn, 10);

        if (scheduleSelected === '0') {
            rater.SendEmailInvitationNow = true;
            const today = new Date();
            const dd = today.getDate();
            let mm: any = today.getMonth() + 1;
            if (mm < 10) { mm = '0' + mm; }
            const yyyy = today.getFullYear();

            const date = `${mm}/${dd}/${yyyy}`;

            const time = new Date();
            let currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
            currentHour = currentHour.split(' ');
            rater.ScheduledFor = date + ' ' + currentHour[0] + ':00 ' + currentHour[1];
        } else {
            rater.SendEmailInvitationNow = false;
            // var sDate = scheduledDate.split('/');
            // rater.ScheduledFor = sDate[1] + '/' + sDate[2] + '/' + sDate[0] + " " + selectedHour;
            // rater.ScheduledTime = this.selectedHour;

            let scheduledFor = $('.wc-date-container span').text();
            // let scheduledForArr = scheduledFor.split(' ');
            // scheduledFor = scheduledForArr[3];
            // scheduledFor = scheduledFor.substr(5);
            scheduledFor = scheduledFor.replace(/-/g, '/');
            console.log('scheduledFor', scheduledFor);

            rater.ScheduledFor = scheduledFor + ' ' + selectedHour;

        }

        console.log('rater', rater);

        // if (rater.Email == "" || rater.FirstName == "" || rater.LastName == "") {
        //    this._Toastr.warning('Empty fields', 'ELI');
        //    return;
        // }

        // if (rater.Email === this.clientEmail) {
        //    this._Toastr.warning("You cannot assign a client as a rater for her/him self.", "ELI");
        //    return;
        // }

        $('body').css('cursor', 'wait');
        this.addingRater = true;

        // if (!this.validateEmail(rater.Email)) {
        //    return;
        // }

        this._ClientsService.postSaveRaters(rater).subscribe((data: any) => {
            console.log('response_PostSaveRater', data);
            if (this._Globals.validationToken(data.result.Result)) {

                switch (data.result.Result) {
                    case -1:
                        this._Toastr.warning('The specified user is already a rater for this assessment.', 'ELI');
                        break;
                    case 0:
                        this._Toastr.error('We are sorry. An error happend while trying to save the client.', 'ELI');
                        break;
                    case 1:
                        this.getRaters();
                        this.getAssignmentRatersConversionRate();
                        this.closeNewRaterModal();
                        this._Toastr.success('Rater added successfully.', 'ELI');
                        break;
                }
                $('body').css('cursor', 'default');
                this.addingRater = false;
            }
        });
    }

    showNewRaterModal(action: any) {
        if (String(action) === 'Add') {
            $('#email').removeClass('disabled');
            this.rater.email = '';
            this.rater.firstName = '';
            this.rater.lastName = '';
            $('#raterTypesSelect option').eq(0).prop('selected', true);
        } else {
            $('#email').addClass('disabled');
            this.rater.email = this.raterForEdit.Email;
            this.rater.firstName = this.raterForEdit.FirstName;
            this.rater.lastName = this.raterForEdit.LastName;
            $('#raterTypesSelect').val(this.raterForEdit.RelationshipId);
        }

        $('#addModal').modal({ backdrop: 'static' });
        $('#addModal').modal('show');
        this.actionForRater = action;

    }

    closeNewRaterModal() {
        $('#addModal').modal('hide');
        console.log('hide');
        this.addRaterPageIdx = 0;
    }

    validateEmail(email: string): boolean {
        console.log('email', email);

        const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        const validEmail = regex.test(email);
        console.log('Valid', validEmail)
        if (validEmail) {
            return true;
        } else {
            this._Toastr.warning('Please enter a valid email address', 'ELI');
            return false;
        }
    }

    preventSpace(value: string, event: any, tagId: string) {
        if (value == null || String(value) === '') {
            if (Number(event.keyCode) === 32) {
                return false;
            }
        }
        if (value === ' ') {
            $(`#${tagId}`).val('');
        }
    }

    addRaterNext() {
        this.addRaterPageIdx++;
        console.log(this.addRaterPageIdx);

        if (this.addRaterPageIdx === 1) {
            setTimeout(() => {
                const time = new Date();
                let currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
                currentHour = currentHour.split(' ');
                this.addNewHour(parseInt(currentHour[0], 10) + 1, currentHour[1]);
            }, 100);
        }
    }

    addRaterPrev() {
        this.addRaterPageIdx--;
        console.log(this.addRaterPageIdx);
    }

    hourChanged() {
        $('input:radio[name=schedule]').eq(0).prop('checked', false);
        $('input:radio[name=schedule]').eq(1).prop('checked', true);
    }

    /*Import Modal*/

    showImportModal() {
        $('#importRaterModal').modal({ backdrop: 'static' });
        $('#importRaterModal').modal('show');
    }

    closeImportModal() {
        $('#importRaterModal').modal('hide');
        $('#iFile').val('');
        this.fileName = '';
        this.blobFile = null;
        this.importRaterPageIdx = 0;

    }

    getBlobFile(event: any) {
        console.log(event);
        let file = event.srcElement.value;
        console.log(file);
        const str = String.raw`\fakepath`;
        file = file.split(str);
        file = file[1].substring(1);
        this.fileName = file;

        this.blobFile = event.target.files[0];
    }

    okImportRaters() {
        $('body').css('cursor', 'wait');
        this.blobToBase64(this.blobFile);
    }

    blobToBase64(blobFile: any) {
        const reader = new FileReader();
        reader.readAsDataURL(blobFile);
        reader.onload = () => {
            console.log('Base64 file', reader.result);
            let base64file: any = reader.result.toString();
            base64file = base64file.split(',');
            this.importClients(base64file[1].toString());
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
            $('body').css('cursor', 'default');
        };
    }

    importClients(base64file: string) {

        const importRatersDto = new ImportRatersDto();


        importRatersDto.clientId = this.clientId;
        importRatersDto.assignmentId = this.assignmentId;
        importRatersDto.data = base64file;

        let scheduledDate = $('.wc-date-container span').text();
        // this.scheduledDate = this.scheduledDate.slice(0, 10);
        const tempDate = scheduledDate.split(' ');
        scheduledDate = tempDate[0];
        scheduledDate = scheduledDate.replace(/-/g, '/');
        console.log('scheduledFor', scheduledDate);

        const language = $('#importLanguages').val();
        console.log('language', language);
        importRatersDto.language = language;


        let expiresIn = $('#importExpiresIn').val();
        console.log('expiresIn', expiresIn);

        const selectedHour = $('#importHour').val();
        // this.selectedGtmText = $("#gtm option:selected").text();
        // this.selectedGtmValue = $('#gtm').val();
        const scheduleSelected = $('input[name=\'schedule\']:checked').val();

        console.log(selectedHour);
        console.log(scheduleSelected);

        let selectedGtmValue: any;
        const d = new Date();
        const n = d.getTimezoneOffset();
        selectedGtmValue = (n / 60);
        importRatersDto.timeOffSet = selectedGtmValue;

        if (expiresIn > 30) { expiresIn = 30; }
        importRatersDto.expiresIn = parseInt(expiresIn, 10);

        if (scheduleSelected === '0') {
            importRatersDto.sendEmailInvitationNow = true;
            const today = new Date();
            const dd = today.getDate();
            let mm: any = today.getMonth() + 1;
            if (mm < 10) { mm = '0' + mm; }
            const yyyy = today.getFullYear();

            const date = `${mm}/${dd}/${yyyy}`;

            const time = new Date();
            let currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
            currentHour = currentHour.split(' ');
            importRatersDto.scheduledFor = date + ' ' + currentHour[0] + ':00 ' + currentHour[1];

        } else {

            importRatersDto.sendEmailInvitationNow = false;

            let scheduledFor = $('.wc-date-container span').text();
            // let scheduledForArr = scheduledFor.split(' ');
            // scheduledFor = scheduledForArr[3];
            // scheduledFor = scheduledFor.substr(5);
            scheduledFor = scheduledFor.replace(/-/g, '/');
            console.log('scheduledFor', scheduledFor);

            importRatersDto.scheduledFor = scheduledFor + ' ' + selectedHour;
        }

        console.dir(importRatersDto);

        this._CoachService.postImportRaters(importRatersDto).subscribe((data: any) => {
            console.log('response_PostImportRaters', data);
            if (this._Globals.validationToken(data.result.Result)) {
                const _data = JSON.parse(data.result.Data);
                console.log('_PostImportRaters data', _data);

                if (Number(data.result.Result) === 0) {
                    this._Toastr.error('An error happened while trying to process the csv file.  Please verify that it is a valid file', 'ELI');
                    $('body').css('cursor', 'default');
                } else if (Number(data.result.Result) === 1) {
                    this._Toastr.success(`Total entries found: ${_data.TotalEntries} Imported: ${_data.SuccessEntries} Failed: ${_data.FailedEntries}`, 'ELI');
                    this.getRaters();
                    this.getAssignmentRatersConversionRate();
                    this.closeImportModal();
                    $('body').css('cursor', 'default');
                }
            }
        });
    }

    importRaterNext() {
        if (this.blobFile == null) {
            this._Toastr.warning('Please select an a .csv file.', 'ELI');
            return;
        }

        this.importRaterPageIdx++;
        console.log(this.importRaterPageIdx);

        if (this.importRaterPageIdx === 1) {
            setTimeout(() => {
                const time = new Date();
                let currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
                currentHour = currentHour.split(' ');
                this.addNewHour(parseInt(currentHour[0], 10) + 1, currentHour[1]);
            }, 100);
        }
    }

    importRaterPrev() {
        this.importRaterPageIdx--;
        console.log(this.importRaterPageIdx);
    }

    importHourChanged() {
        $('input:radio[name=schedule]').eq(0).prop('checked', false);
        $('input:radio[name=schedule]').eq(1).prop('checked', true);
    }

    onDateSelect(date) {
        $('input:radio[name=schedule]').eq(0).prop('checked', false);
        $('input:radio[name=schedule]').eq(1).prop('checked', true);

        date.setHours(0, 0, 0, 0);
        console.log('onDateSelect', date);

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        console.log('today', today);

        if (date < today) {
            this._Toastr.warning('Please enter a date and time greater than the current date and time.', 'ELI');
            this.date1 = new Date();
            this.importDate = new Date();


            const time = new Date();
            let currentHour: any = time.toLocaleString('en-US', { hour: 'numeric', hour12: true });
            currentHour = currentHour.split(' ');
            currentHour[0] = parseInt(currentHour[0], 10);
            if (Number(currentHour[0]) === 12) {
                currentHour[0] = 0;
            }
            currentHour[0] = (currentHour[0] + 1) + '';

            if (currentHour[0].length === 1) {
                currentHour[0] = '0' + currentHour[0];
            }

            if (Number(currentHour[0]) === 12) {
                currentHour[1] = 'PM';
            }
            currentHour = currentHour[0] + ':00 ' + currentHour[1];
            console.log('current Hour', currentHour);
            $('#hour').val(currentHour);
            $('#importHour').val(currentHour);
        }
    }

    addNewHour(minHour: number, type: string) {

        if (Number(minHour) === 13) {
            minHour = 1;
        }

        const amHours = [];
        const pmHours = [];

        if (type === 'AM') {
            for (let i = minHour; i <= 11; i++) {
                if (i >= 10) {
                    amHours.push(i + ':00 AM');
                } else {
                    amHours.push('0' + i + ':00 AM');
                }
            }
            // adding the rest pm hours
            amHours.push('12:00 PM');
            minHour = 1;
            for (let j = minHour; j < 12; j++) {
                if (j >= 10) {
                    pmHours.push(j + ':00 PM');
                } else {
                    pmHours.push('0' + j + ':00 PM');
                }
            }
        } else {
            if (Number(minHour) === 12) {
                amHours.push('12:00 PM');
                minHour = 1;
            }
            // tslint:disable-next-line: no-shadowed-variable
            for (let i = minHour; i < 12; i++) {
                if (i >= 10) {
                    pmHours.push(i + ':00 PM');
                } else {
                    pmHours.push('0' + i + ':00 PM');
                }
            }
        }
        console.log('this.hours', this.hours);
        this.hours = amHours.concat(pmHours);

    }

    onRaterRowClicked(e) {
        console.log(e);
        // if (!this.reportGenerated) {
        //    this.raterForEdit = e.data;
        //    console.log('Selected rater', this.raterForEdit);
        //    this.showNewRaterModal('Edit');
        // }
    }

    getSelectedRows(gridApi): any {
        console.log('SELECTED', gridApi.getSelectedRows());
        return gridApi.getSelectedRows();
    }

    postUpdateRater() {

        const rater = new UpdateRaterDto;
        rater.assignmentId = this.assignmentId;
        rater.firstName = this.rater.firstName;
        rater.lastName = this.rater.lastName;
        rater.raterId = this.raterForEdit.RaterId;
        rater.relationship = parseInt($('#raterTypesSelect').val(), 10);

        if (rater.firstName === '' || rater.lastName === '') {
            this._Toastr.warning('Empty fields.', 'ELI');
            return;
        }

        this._CoachService.postUpdateRater(rater).subscribe((data: any) => {
            console.log('response_postUpdateRater', data);
            if (this._Globals.validationToken(data.result.Result)) {
                this.closeNewRaterModal();

                if (Number(data.result.Result) === 1) {
                    this.getRaters();


                } else if (Number(data.result.Result) === 0) {
                    this._Toastr.error('We are sorry. An error happened when trying to update the rater.', 'ELI');
                }
            }
        });
    }

    backTo() {
        console.log('back to...', this.from);
        // if (this.from == 'manage_clients') {
        //    this._Globals.navigate('edit_clients');
        // } else {
        //    if (this.from == 'manage_assessments_completed') this._Globals.showCompletedAssessments = true;
        //    this.router.navigate(['/app/coach_assessments']);
        // }

        switch (this.from) {
            case 'manage_clients':
                this._Globals.navigate('edit_clients');
                break;

            case 'manage_assessments_completed':
                this._Globals.showCompletedAssessments = true;
                this.router.navigate(['/app/coach_assessments']);
                break;

            case 'manage_assessments_assigned':
                this._Globals.showCompletedAssessments = false;
                this.router.navigate(['/app/coach_assessments']);
                break;

            default:
                this.router.navigate(['/app/coach_assessments']);
        }
    }

    /*GENERATE REPORT MODAL*/
    showConfirmationGenerateReportModal() {
        $('#confirmationGenerateReportModal').modal({ backdrop: 'static' });
        $('#confirmationGenerateReportModal').modal('show');
    }

    hideConfirmationGenerateReportModal() {
        $('#confirmationGenerateReportModal').modal('hide');
    }


    /*ratersModal*/
    showRatersModal() {
        this._Globals.refreshTableOnAssessmentsResults = true;
        this.ratersModal.show(this.assignmentId, this.assessmentIdClientId, 0, this.clientEmail);
    }

    exporRaterComments() {
        this.progressRef.start();
        this._RatersService.exporRaterComments(this.assignmentId).subscribe((data: any) => {
            console.log('response_exporRaterComments', data);
            if (this._Globals.validationToken(data.result.Result)) {
                switch (data.result.Result) {
                    case -1:
                        this._Toastr.warning('No comments to export', 'ELI');
                        this.progressRef.complete();
                        break;

                    case 0:
                        this._Toastr.error('We are sorry. An unexpected error happened while trying to download the comments', 'ELI');
                        this.progressRef.complete();
                        break;

                    case 1:
                        $('body').css('cursor', 'waiting');

                        const _data = JSON.parse(data.result.Data);
                        console.log('_data', _data);
                        const fileName = '360_Assessement_' + this.client_first_name + '_' + this.client_last_name + '_Rater_Comments.csv';
                        const base64File = _data;
                        this.saveFile(fileName, base64File);
                        break;
                }
            }
        });
    }

    saveFile(name, data) {
        /*base64 to string*/
        data = atob(data);

        setTimeout(() => {
            $('body').css('cursor', 'default');
            this.progressRef.complete();
        }, 1000);
        if (data != null && navigator.msSaveBlob) {
            return navigator.msSaveBlob(new Blob([data], { type: 'text/csv' }), name);
        }

        const a = $('<a style=\'display: none;\'/>');
        const url = window.URL.createObjectURL(new Blob([data], { type: 'text/csv' }));
        a.attr('href', url);
        a.attr('download', name);
        $('body').append(a);
        a[0].click();
        window.URL.revokeObjectURL(url);
        a.remove();
    }

    public getStatusLabel(statusId: number) {
/*        console.log('status', statusId);*/
        switch (statusId) {
            case 1:
                return 'Invitation Sent';

            case 2:
                return 'In progress';

            case 3:
                return 'Completed';
        }
    }

    sendReminderEmailtoRaters(): void {
        if (this.sendingReminderEmails === true) {
            return;
        }
        this.progressRef.start();
        this.sendingReminderEmails = true;
        this._CoachService.postSendReminderEmailToRaters(this.assignmentId)
            .subscribe((response: any) => {
                console.log('response_postSendReminderEmailToRaters', response);
                if (this._Globals.validationToken(response.result.Result)) {
                    if (Number(response.result.Result) == 0) {
                        this._Toastr.error('We are sorry. An error happened when trying to send the reminder emails.', 'ELI');
                    } else {
                        this._Toastr.success('Reminder emails sent', 'Successful');
                    }
                }
            },
            (error) => {
                this.sendingReminderEmails = false;
                this.progressRef.complete();
            },
            () => {
                this.sendingReminderEmails = false;
                this.progressRef.complete();
            })
    }

    private subscriptions(): void {
        this.reminderModal.response.subscribe((result: string) => {
            if(result === 'okay') {
                this.checkBoxReminderEnabled = false;

                this.sendReminderEmails = !this.sendReminderEmails;
                this._CoachService.postUpdateSendReminderEmail(this.assignmentId.toString(), this.sendReminderEmails)
                .subscribe((response: any) => {
                    console.log('response_postUpdateSendReminderEmail', response);
                    if (this._Globals.validationToken(response.result.Result)) {
                        if (response.result.Result == 0) {
                            this._Toastr.error('We are sorry. An error happened when trying to update the reminder email status.', 'ELI');
                        } else {
                            this._Toastr.success('Reminder email status updated', 'Successful');
                        }
                    }
                },
                // error
                (error) => {
                    this.checkBoxReminderEnabled = true;
                },
                // complete
                () => {
                    this.checkBoxReminderEnabled = true;
                });
            }
        });
    }

    private getAssignmentReminderEmailStatus(): void {
        this._CoachService.GetReminderEmailStatusForAssignmentId(this.assignmentId)
            .subscribe((response: any) => {
                console.log('response_getAssignmentReminderEmailStatus', response);
                    if (this._Globals.validationToken(response.result.Result)) {
                        if (Number(response.result.Result) === 0) {
                            this._Toastr.error('We are sorry. An error happened when trying to get the reminder email status.', 'ELI');
                        } else {
                            const _data = JSON.parse(response.result.Data);
                            console.log('_data', _data);
                            this.sendReminderEmails = _data;
                        }
                    }
            },
            (error) => {

            },
            () => {

            });
    }
}
